import { FC } from 'react';

import { Icon } from '@shared/components/icons';
import { IconFormer } from '@shared/components/IconsFormer';

export const CustomerCallCenterBox: FC = function CustomerCenterBox() {
  const { CustomerCenter } = Icon();

  const promotionText = () => {
    return (
      <p>
        정성을 담은 <span className="theme-text-main">감사의 답례품</span>
      </p>
    );
  };

  return (
    <div className="p-4 py-4 theme-bg-1">
      <div className="center-box text-base font-bold">{promotionText()}</div>
      <div className="center-box relative gap-4 font-bold">
        <div className="center-box flex-col items-center">
          <CustomerCenter />
          <p className="">전화주문 및 안내</p>
          <p className="theme-text-main">오전9시 - 오후6시</p>
        </div>
        <div className="space-y-2">
          <a href={`tel:18006987`}>
            <div className="flex items-center gap-2 text-[21px]">
              <IconFormer.Phone className="wh-5 fill-gray-700" />
              <p>1800-6987</p>
            </div>
          </a>
          <p className="text-xs">클릭 시 상담원에게 바로 연결됩니다</p>
        </div>
      </div>
    </div>
  );
};
